<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<aside class="side-navigation noselect" id="leftMenuItems">
	<ul class="list-unstyled" >
		<lms-menu-item *ngFor="let menuItem of menuItems; let i = index;" [tabsIndex]="tabLevel + i*100" [currentUrl]="currentUrl" [editMode]="editMode"
			[tabs]="tabs" [menuItem]="menuItem" [ngClass]="{selected: (selectedType == menuItem.type)}" (lmsTabChange)="lmsEventHandler($event)">
		</lms-menu-item>
	</ul>
</aside>